import React from 'react'

import Caption from '../Caption/Caption.index'
import { ImageProps } from './Image.types'

const Image: React.FC<ImageProps> = (props) => {
  const {
    alt,
    byline,
    caption,
    componentCaption: RenderCaption,
    componentImage: RenderImage,
    captionProps,
    imageProps,
    isFullWidth,
    linkHref,
    linkTarget,
    src
  } = props
  let textValue: Array<string> = []
  caption && textValue.push(caption)
  byline && textValue.push(`(${byline})`)
  if (src) {
    return (
      <>
        <RenderImage
          alt={caption || alt}
          linkHref={linkHref}
          linkTarget={linkTarget}
          isFullWidth={isFullWidth}
          src={src}
          {...imageProps}
        />
        <RenderCaption
          captionProps={captionProps}
          isFullWidth={isFullWidth}
          value={textValue.join(' ')}
        />
      </>
    )
  }
  return <RenderImage />
}

Image.defaultProps = {
  as: 'h3',
  componentCaption: Caption,
  variant: 'newstitle-2xl'
}

export default Image
